module.exports = __webpack_public_path__ + "img/welfare-zbit.a8f8f19c.png";